module.exports = __webpack_public_path__ + "img/5-U19.1ee8379.png";